<template>
  <el-dialog
    :visible.sync="isVisible"
    title="Import Invoice"
    width="70vw"
    top="5vh"
    :close-on-click-modal="false"
    :fullscreen="isFullscreen"
    @closed="$emit('destroy')"
  >
    <InvoiceImportStepOne
      v-if="step === 1"
      ref="stepOne"
      :form="form"
      @submitted="(submitted) => { stepOneSubmitted = submitted }"
    />
    <InvoiceImportStepTwo
      v-if="step === 2"
      ref="stepTwo"
      :form="form"
      @submitted="(newParsed) => { parsed = newParsed }"
    />
    <InvoiceImportStepThree
      v-if="step === 3"
      ref="stepThree"
      :form="form"
      :parsed="parsed"
      @processed="onProcessed"
    />
    <InvoiceImportStepFour
      v-if="step === 4"
      ref="stepFour"
      :form="form"
      :processed="processed"
      @close="$emit('destroy')"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isVisible = false">
        Cancel
      </el-button>
      <el-button
        v-if="step === 1 || step === 2"
        type="primary"
        @click.native="tryNext()"
      >
        Next
      </el-button>
      <el-button
        v-if="step === 3"
        :disabled="processed.length === 0"
        type="primary"
        @click.native="tryFinish()"
      >
        Finish
      </el-button>
      <el-button
        v-if="step === 4"
        type="success"
        @click.native="save()"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import InvoiceImportStepOne from '@/components/Application/Billing/Invoices/InvoiceImportStepOne'
import InvoiceImportStepTwo from '@/components/Application/Billing/Invoices/InvoiceImportStepTwo'
import InvoiceImportStepThree from '@/components/Application/Billing/Invoices/InvoiceImportStepThree'
import InvoiceImportStepFour from '@/components/Application/Billing/Invoices/InvoiceImportStepFour'
export default {
  components: {
    InvoiceImportStepOne,
    InvoiceImportStepTwo,
    InvoiceImportStepThree,
    InvoiceImportStepFour
  },
  data () {
    return {
      isFullscreen: false,
      isVisible: true,
      form: {
        account: null,
        carrier: null
      },
      stepOneSubmitted: false,
      parsed: [],
      processed: [],
      step: 1
    }
  },
  methods: {
    tryNext () {
      switch (this.step) {
        case 1: {
          this.$refs.stepOne.submit()
          this.$nextTick(() => {
            if (this.stepOneSubmitted) {
              this.$set(this, 'step', 2)
            }
          })
          break
        }
        case 2: {
          this.$refs.stepTwo.next()
          this.$nextTick(() => {
            if (this.parsed.length > 0) {
              this.$set(this, 'step', 3)
            }
          })
          break
        }
      }
    },
    tryFinish () {
      if (this.processed.length > 0) {
        this.$set(this, 'step', 4)
      }
    },
    save () {
      this.$refs.stepFour.save()
    },
    onProcessed (newProcessed) {
      this.$set(this, 'processed', newProcessed)
    }
  }
}
</script>
